// Generated by BUCKLESCRIPT VERSION 5.0.3, PLEASE EDIT WITH CARE
'use strict';

var Css = require("bs-css/src/Css.js");
var React = require("react");
var Feature = require("./Feature.bs.js");

var container = Css.style(/* :: */[
      Css.display(/* flex */-1010954439),
      /* :: */[
        Css.flexWrap(/* wrap */-822134326),
        /* :: */[
          Css.justifyContent(/* spaceAround */-485895757),
          /* [] */0
        ]
      ]
    ]);

var Styles = /* module */[/* container */container];

function Features(Props) {
  return React.createElement("div", {
              className: container
            }, React.createElement(Feature.make, {
                  emoji: /* Checkmark */0,
                  text: "Simple operations"
                }), React.createElement(Feature.make, {
                  emoji: /* Checkmark */0,
                  text: "Decimals"
                }), React.createElement(Feature.make, {
                  emoji: /* Checkmark */0,
                  text: "Percentage"
                }), React.createElement(Feature.make, {
                  emoji: /* Checkmark */0,
                  text: "Positive/Negative"
                }), React.createElement(Feature.make, {
                  emoji: /* Soon */1,
                  text: "Advanced options"
                }), React.createElement(Feature.make, {
                  emoji: /* Soon */1,
                  text: "Operation history"
                }));
}

var make = Features;

exports.Styles = Styles;
exports.make = make;
/* container Not a pure module */
